import { type EnumType } from './EnumType';
import { type PermissionDto } from './PermissionDto';

export type AccountDetailsDto = {
  id?: string;
  profile_picture_url?: string;
  profile_picture_id?: string;
  name?: string;
  role?: string;
  type?: EnumType;
  telephone?: string;
  email?: string;
  google_account?: boolean;
  environment_id?: string;
  first_access?: boolean;
  theme?: EnumType;
  full_access?: boolean;
  permissions?: PermissionDto[];
};

export const initialAccountDetailsEmpty: AccountDetailsDto = {
  name: '',
  role: '',
  telephone: '',
};
